import { createSelector } from '@reduxjs/toolkit';
import { scaleOrdinal } from 'd3-scale';
import { DefaultRootState } from 'react-redux';
import { sortLeads } from '../../plot/utils/lead';
import { LEAD_COLOR_SCHEME } from '../../utils/colors';

export const signalSelector = ({ signal }: DefaultRootState) => signal;

export const leadDataSelector = createSelector(
  signalSelector,
  ({ leads }) => leads,
);

export const signalLoadedSelector = createSelector(
  leadDataSelector,
  (leads) => Object.keys(leads).length > 0,
);

export const frequencySelector = createSelector(
  signalSelector,
  ({ frequency }) => frequency,
);

export const leadNamesSelector = createSelector(leadDataSelector, (leads) =>
  Object.keys(leads).sort(sortLeads),
);

export const leadCountSelector = createSelector(
  leadNamesSelector,
  (leads) => leads.length,
);

export const leadColorScaleSelector = createSelector(
  leadNamesSelector,
  (leads) =>
    scaleOrdinal<string, string>().domain(leads).range(LEAD_COLOR_SCHEME),
);
